import "./../../css/style.css";
import TroqueFut from "../../componentsStyled/icon/LogoTroqueFut";
import IconAcomp from "../../componentsStyled/icon/IconAcomp";
import IconRequest from "../../componentsStyled/icon/IconRequest";
import { Box, Button, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ChatFlutuant from "../../components/ChatFlutuant";
import HeaderTopLinks from "../../components/headerTopLinks";

export default function Start() {
  const navigate = useNavigate();

  const handleCheckLogin = async (page: string, pageDestiny) => {
    const authExist = localStorage.getItem("auth");
    if (authExist?.length > 0) {
      navigate(page);
    } else {
      navigate("/login", { state: pageDestiny });
    }
  };

  return (
    <div className="bgellipse">
      {/* desktop */}
      <Box display={{ xs: "none", md: "initial" }}>
        <HeaderTopLinks />
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "80vh", gap: 40 }}>
          <TroqueFut width={364} className="logo-troque" />
          <Box display={"flex"} flexDirection={{ xs: "column", md: "row" }} gap={5}>
            <Box width={{ xs: 300, md: 180 }} height={{ xs: 100, md: 180 }}>
              <Button
                onClick={() => handleCheckLogin("/order", "order")}
                variant="outlined"
                style={{ borderColor: "#C2282B", borderWidth: 3, borderRadius: 9, display: "flex", flexDirection: "column", width: "100%", height: "100%" }}>
                <IconAcomp width={99} />
                <span style={{ color: "#C2282B", fontWeight: 400 }}>Faça uma nova solicitação</span>
              </Button>
            </Box>
            <Box width={{ xs: 300, md: 180 }} height={{ xs: 100, md: 180 }}>
              <Button
                onClick={() => handleCheckLogin("/devolution", "devolution")}
                variant="outlined"
                style={{ borderColor: "#b6b6b6", borderWidth: 3, borderRadius: 9, display: "flex", flexDirection: "column", width: "100%", height: "100%" }}>
                <IconRequest width={41} />
                <span style={{ color: "#21222DA3", fontWeight: 400 }}>Acompanhe sua solicitação</span>
              </Button>
            </Box>
          </Box>
        </div>
      </Box>
      {/* desktop */}

      {/* Mobile */}
      <Box display={{ xs: "flex", md: "none" }} flexDirection={"column"} justifyContent={"center"} alignItems={"center"} height={"100vh"} gap={5}>
        <TroqueFut width={364} className="logo-troque" />
        <Box display={"flex"} flexDirection={{ xs: "column", md: "row" }} gap={5}>
          <Box width={{ xs: 300, md: 180 }} height={{ xs: 100, md: 180 }}>
            <Button
              onClick={() => handleCheckLogin("/order", "order")}
              variant="outlined"
              style={{ borderColor: "#C2282B", borderWidth: 3, borderRadius: 9, display: "flex", flexDirection: "column", width: "100%", height: "100%" }}>
              <IconAcomp width={99} />
              <span style={{ color: "#C2282B", fontWeight: 400 }}>Faça uma nova solicitação</span>
            </Button>
          </Box>
          <Box width={{ xs: 300, md: 180 }} height={{ xs: 100, md: 180 }}>
            <Button
              onClick={() => handleCheckLogin("/devolution", "devolution")}
              variant="outlined"
              style={{ borderColor: "#b6b6b6", borderWidth: 3, borderRadius: 9, display: "flex", flexDirection: "column", width: "100%", height: "100%" }}>
              <IconRequest width={41} />
              <span style={{ color: "#21222DA3", fontWeight: 400 }}>Acompanhe sua solicitação</span>
            </Button>
          </Box>
        </Box>
      </Box>
      {/* Mobile */}

      <ChatFlutuant />
    </div>
  );
}
